import { useState, useEffect } from 'react';
import api from '../api/axios';

// Every place a form can refer to, in one list: CarSaloon sites, inspection locations and dealerships
// (active ones only — anything switched off in Settings stays hidden). One failing list doesn't hide the
// others, and a name that appears in more than one list is shown once.
export function useAllLocations() {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    let alive = true;
    Promise.allSettled([
      api.get('/jobs/locations'),
      api.get('/users/site-locations'),
      api.get('/jobs/dealerships'),
    ]).then(([sites, inspection, dealers]) => {
      const names = (r, key) => (r.status === 'fulfilled' ? (r.value.data[key] || []) : []).map(x => x.name).filter(Boolean);
      const seen = new Set();
      const built = [
        { label:'CarSaloon sites',      items: names(sites, 'locations') },
        { label:'Inspection locations', items: names(inspection, 'locations') },
        { label:'Dealerships',          items: names(dealers, 'dealerships') },
      ].map(g => ({
        ...g,
        items: g.items.filter(n => { const k = n.trim().toLowerCase(); if (seen.has(k)) return false; seen.add(k); return true; })
                      .sort((a, b) => a.localeCompare(b)),
      })).filter(g => g.items.length);
      if (alive) setGroups(built);
    });
    return () => { alive = false; };
  }, []);

  return groups;
}

// The <option> list for a <select>: one plain A–Z list (no headings). Duplicates were already removed above.
export default function LocationOptions({ groups }) {
  return groups.flatMap(g => g.items)
    .sort((a, b) => a.localeCompare(b))
    .map(n => <option key={n} value={n}>{n}</option>);
}
